import { getMember } from '../get-member';
export const getMemberBalances = () => { var _a; return (_a = getMember()) === null || _a === void 0 ? void 0 : _a.balances; };
